export default "__VITE_ASSET__DG9Vi$0H__"